module.exports = __webpack_public_path__ + "static/media/si-glass.afc5f7c2.png";